import { withSearch } from '@elastic/react-search-ui';
import MultiChoiceAsyncSelect from '../../../components/filter/MultiChoiceAsyncSelect';

function NHLEAssociatedPersonFilter({ addFilter, removeFilter, filters }) {
  return (
    <MultiChoiceAsyncSelect
      addFilter={addFilter}
      fieldId="person"
      filters={filters}
      formHint="For example, Florence Nightingale"
      id="associated-person"
      label="Associated person"
      removeFilter={removeFilter}
    />
  );
}

export default withSearch(({ addFilter, removeFilter, filters }) => ({
  addFilter,
  removeFilter,
  filters,
}))(NHLEAssociatedPersonFilter);
